export default __webpack_public_path__ + "static/media/portrait_pilat.f3bbb134.jpg";